<label class="sg-checkbox mb-0" 
    [ngClass]="{ 
        '-small': size, 
        '-button': checkboxStyle === 'button',
        '-checked': isTicked && checkboxStyle === 'button' }"
    role="checkbox">
    <span class="sg-checkbox__label" [ngClass]="{'-fullsize': checkboxStyle === 'button'}"><ng-content></ng-content></span>
    <input class="sg-checkbox__input" type="checkbox" [checked]="isTicked" (change)="update()">
    <span class="sg-checkbox__checkmark" 
        [ngClass]="{ 
            '-small': size, 
            '-secondary': checkboxStyle === 'secondary',
            '-checked': isTicked,
            'd-none': checkboxStyle === 'button'
        }"></span>
</label>